<script>
import { SiteSettings } from '@/api/'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { cloneDeep } from 'lodash'

export default {
  components: {},
  mixins: [FormMixin],
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.service.get().then(response => {
        this.form = response.data
        this.prepareFormCopyToPreventChangesLost()
      })
    },
    onSubmit() {
      this.loading = true
      const service = this.service.update(this.form)
      service
        .then(this.successHandler)
        .then(() => {
          this.formCopy = cloneDeep(this.form)
        })
        .catch(this.errorHandler)
    },
    getFields() {
      return [
        new fields.Input({
          label: 'Link do facebooka',
          modelPath: [this, 'form', 'facebook_url']
        }),
        new fields.Input({
          label: 'Link do twittera',
          modelPath: [this, 'form', 'twitter_url']
        }),
        new fields.Input({
          label: 'Link do youtube',
          modelPath: [this, 'form', 'youtube_url']
        }),
        new fields.Input({
          label: 'Link do instagrama',
          modelPath: [this, 'form', 'instagram_url']
        })
      ]
    }
  },
  computed: {
    service() {
      return SiteSettings
    }
  }
}
</script>
